import React from "react"
import Home from "./home/Home"
import Info from "./info/Info"
import Profile from "./profile/Profile"
import Reach from "./reach/Reach"
import Eutr from "./eutr/Eutr"
import Viewer from "./viewer/Viewer"
import Admin from "./admin/Admin"
import {Route, Redirect, Switch, withRouter, RouteComponentProps} from "react-router-dom";
import PrivateRoute from "../common/component/PrivateRoute";
import {withTranslation, WithTranslation} from "react-i18next";
import {compose} from "redux";
import {connect} from "react-redux";
import {AppState} from "../store";
import {UserState} from "../store/user/types";

type ContentProps = RouteComponentProps & WithTranslation & {
    userState: UserState;
}

class SowContent extends React.Component <ContentProps, {}> {
    render() {
        return (
            <div>
                <Switch>
                    <Route path="/app/home" component={() => <Home/>}/>
                    <PrivateRoute isLoggedIn={this.props.userState.isLoggedIn} path="/app/reach"
                                  component={() => <Reach t={this.props.t}/>}/>
                    <PrivateRoute isLoggedIn={this.props.userState.isLoggedIn} path="/app/eutr"
                                  component={() => <Eutr/>}/>
                    <PrivateRoute isLoggedIn={this.props.userState.isLoggedIn} path="/app/viewer"
                                  component={() => <Viewer t={this.props.t}/>}/>
                    <PrivateRoute isLoggedIn={this.props.userState.isLoggedIn} path="/app/info"
                                  component={() => <Info t={this.props.t}/>}/>
                    <PrivateRoute isLoggedIn={this.props.userState.isLoggedIn} path="/app/profile"
                                  component={() => <Profile t={this.props.t}/>}/>
                    <PrivateRoute isLoggedIn={this.props.userState.isLoggedIn} path="/app/admin"
                                  component={() => <Admin t={this.props.t}/>}/>
                    <Redirect from="/" to="/app/home"/>
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    userState: state.user
});

export default compose(
    withTranslation('common'),
    withRouter,
    connect(
        mapStateToProps
    )
)(SowContent) as any;